<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="450px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="isNewAdditionalShippingLabel">
                        Tworzenie etykiety dodatkowej
                    </template>
                    <template v-else>
                        Wydruk etykiety dodatkowej
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="additionalShippingLabel.destinationId"
                                label="Przeznaczenie"
                                :items="destinations"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono"
                                clearable
                                outlined
                                dense
                                :disabled="!isNewAdditionalShippingLabel"
                                :error-messages="destinationIdErrors"
                            />
                            <v-text-field
                                v-model="additionalShippingLabel.palletsQuantity"
                                label="Liczba palet"
                                type="number"
                                suffix="szt."
                                outlined
                                dense
                                :disabled="!isNewAdditionalShippingLabel"
                                :error-messages="palletsQuantityErrors"
                            />
                            <v-select
                                v-model="additionalShippingLabel.palletTypeId"
                                label="Rodzaj palety"
                                :items="pallets"
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono palet"
                                outlined
                                clearable
                                dense
                                :disabled="!isNewAdditionalShippingLabel"
                                :error-messages="palletTypeIdErrors"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Drukuj"
                    :loading="actionLoading"
                    @click="onSave"
                >
                    <template>
                        Drukuj
                    </template>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, minValue, integer } from 'vuelidate/lib/validators'
import { isEmpty } from 'lodash'

export default {
    name: 'AdditionalShippingLabelDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        destinations: {
            type: Array,
            default: () => []
        },
        pallets: {
            type: Array,
            default: () => []
        },
        additionalShippingLabelData: {
            type: Object,
            default: () => {}
        },
        actionLoading: {
            type: Boolean
        },
    },
    data() {
        return {
            additionalShippingLabel: {
                destinationId: null,
                palletsQuantity: null,
                palletTypeId: 31,
                shippingLabelTemplateId: 3,
                shippingLabelId: null
            }
        }
    },
    validations: {
        additionalShippingLabel: {
            destinationId: {
                required
            },
            palletsQuantity: {
                required,
                integer,
                minValue: minValue(1),
            },
            palletTypeId: {
                required
            }
        }
    },
    computed: {
        isNewAdditionalShippingLabel() {
            return isEmpty(this.additionalShippingLabelData)
        },
        destinationIdErrors() {
            const errors = []

            if (!this.$v.additionalShippingLabel.destinationId.$dirty) return errors
            !this.$v.additionalShippingLabel.destinationId.required && errors.push('Proszę wybrać przeznaczenie.')

            return errors
        },
        palletsQuantityErrors() {
            const errors = []

            if (!this.$v.additionalShippingLabel.destinationId.$dirty) return errors

            if (!this.$v.additionalShippingLabel.palletsQuantity.required) {
                errors.push('Liczba palet jest wymagana')
            }

            if (!this.$v.additionalShippingLabel.palletsQuantity.minValue || !this.$v.additionalShippingLabel.palletsQuantity.integer) {
                errors.push('Proszę podać całkowitą dodatnią liczbę palet')
            }

            return errors
        },
        palletTypeIdErrors() {
            const errors = []

            if (!this.$v.additionalShippingLabel.palletTypeId.$dirty) return errors
            !this.$v.additionalShippingLabel.palletTypeId.required && errors.push('Proszę wybrać rodzaj palety.')

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if ((boolean)) {
                if (!isEmpty(this.additionalShippingLabelData)) {
                    this.additionalShippingLabel = JSON.parse(JSON.stringify(this.additionalShippingLabelData))
                    this.additionalShippingLabel.shippingLabelId = this.additionalShippingLabel.id
                } else {
                    this.additionalShippingLabel.palletTypeId = 31
                }
            } else {
                setTimeout(() => {
                    this.$v.$reset()
                    this.additionalShippingLabel = {}
                    this.additionalShippingLabel.shippingLabelTemplateId = 3
                    this.additionalShippingLabel.palletTypeId = 31
                    this.additionalShippingLabel.palletsQuantity = null
                    this.additionalShippingLabel.destinationId = null
                    this.additionalShippingLabel.shippingLabelId = null
                }, 500)
            }
        },
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            if (this.isNewAdditionalShippingLabel) {
                this.$emit('on-submit', this.additionalShippingLabel)
            } else {
                this.$emit('on-print', this.additionalShippingLabel )
            }
        },
        onClose() {
            this.$v.$reset()
            this.$emit('on-close')
        }
    }
}
</script>